






































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import RouteTranslations from "@/locales/routerTranslations";
import GenericCard from "@/components/stateless/GenericCard.vue";
import Region from "@/models/region";
import { CellarsRequests } from "@/helpers";
import VueScrollTo from "vue-scrollto";
import InfiniteLoading from "vue-infinite-loading";

Vue.use(VueScrollTo);

@Component({
  components: {
    GenericCard,
    InfiniteLoading
  }
})
export default class CellarsList extends Vue {
  translations: any = RouteTranslations;
  cellarsList: Array<any> = [];
  queryString: string = "";
  @Prop({ default: [] }) private regions!: Array<any>;
  page: number = 1;
  total: number = 0;
  loading: boolean = false;
  shouldScroll: boolean = false;
  firstLoad: boolean = true;
  infiniteId = +new Date();

  @Watch("regions", { immediate: true, deep: true })
  onRegionsChanged(val: Region[]) {
    console.warn("this.queryString: ", this.queryString);
    new Promise((resolve, reject) => {
      this.page = 1;
      this.cellarsList = [];
      this.total = 0;
      this.queryString = ""

      if (val.length > 0) {
        this.regionsQueryFilters(val);
      }

      resolve(this.$store.dispatch("app/refreshSearchFilters", {
        queryString: this.queryString
      }))
    })
      .finally(() => this.infiniteId += 1)

    // this.queryString = "&page=" + this.page + "&per_page=48";
    // this.getCellars(undefined, this.queryString);

  }

  mounted() {
    // this.getCellars("");
  }
  regionsQueryFilters(regions: Region[]) {
    this.shouldScroll = true;
    this.queryString += "&region_ids=";
    regions.map((region: Region, index) => {
      this.queryString += `${region.id}`;
      if (index < regions.length - 1) this.queryString += ",";
    });
  }
  getCellars($state?: any, filters?: any) {
    if (this.loading) return;
    this.loading = true;
    CellarsRequests.fetchAll(filters)
      .then((response: any) => {
        if (response.data.length) {
          this.page += 1
          this.cellarsList.push(...response.data);
          this.total = response.meta.total;
          $state && $state.loaded();
        } else {
          this.total = response.data.total > 0 ? response.data.total : 0
          $state && $state.complete();
        }
        this.loading = false;
        if (this.firstLoad) {
          this.firstLoad = false;
        }
        if (this.shouldScroll) {
          this.shouldScroll = false;
          this.scrollToCellars();
        }
      })
      .catch((error: Error) => {
        this.loading = false;
        this.$store.dispatch("app/setSnackbarMessage", {
          message: error,
          color: "red"
        });
      });
  }

  loadMoreCellars($state: any) {
    let filters = this.$store.state.app.searchFilters.queryString;
    filters = filters + "&page=" + this.page + "&per_page=36";
    this.getCellars($state, filters);
  }

  scrollToCellars() {
    VueScrollTo.scrollTo('#scroll-target', 500, { offset: -80 });
  }
}
